import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../../../common';

export function loadPersons() {
    return async (dispatch, getState) => {
        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/pickers/users`);
        dispatch({
            type: t.LOAD_PERSONS,
            payload: resp.data
        })
    };
}






